import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { rootRedirectGuard } from 'app/core/auth/guards/root-redirect.guard';
import { unknownRouteGuard } from 'app/core/auth/guards/unknown-route.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { LoginService } from 'app/modules/login/login.service';
import { SignInvalidComponent } from './modules/DocSign/review-and-sign/sign-invalid/sign-invalid.component';
import { SignSuccessComponent } from './modules/DocSign/review-and-sign/sign-success/sign-success.component';

export const appRoutes: Route[] = [

  // Exact `/` — must be first so guest/admin empty parents don't swallow it
  { path: '', pathMatch: 'full', canActivate: [rootRedirectGuard], children: [] },

  // Auth routes for guests
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: 'login', loadChildren: () => import('app/modules/login/login.routes') },

      { path: 'forgot-password', loadChildren: () => import('app/modules/forgot-password/forgot-password.routes') },

      { path: 'reset-password', loadChildren: () => import('app/modules/reset-password/reset-password.routes') },

      { path: 'client_registration', loadChildren: () => import('app/modules/client-registration/client-registration.routes') },

      { path: 'login-support', loadChildren: () => import('app/modules/login-support/login-support.routes') },
      {
        path: 'report-temp/:id/:id/:id/:id/detail/:id', loadChildren: () => import('app/modules/report-temp/report-temp.routes'),
        data: { title: 'Report' }
      },
      {
        path: 'sign/document/:documentId', loadChildren: () => import('app/modules/DocSign/review-and-sign/review-and-sign.routes'),
        //data: { title: 'Review and sign' },
      },
      {
        path: 'sign-invalid',
        component: SignInvalidComponent
      },
      {
        path: 'sign-success',
        component: SignSuccessComponent
      }
    ]
  },

  // Admin routes (session checked by LoginService → login if expired)
  {
    path: '',
    canActivate: [LoginService],
    //canActivateChild: [LoginService],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver
    },
    children: [

      { path: 'dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes') },

      {
        path: 'select-company', loadChildren: () => import('app/modules/select-client/select-client.routes'),
        data: { title: 'Select Company' },
      },

      {
        path: 'account', loadChildren: () => import('app/modules/account-settings/account-settings.routes'),
        data: { title: 'Account Setting' }
      },

      {
        path: 'live-tracking', loadChildren: () => import('app/modules/Tracker/live-tracking/live-tracking.routes'),
        data: { title: 'Live Tracking' }
      },

      {
        path: 'tracking-history', loadChildren: () => import('app/modules/Tracker/tracking-history/tracking-history.routes'),
        data: { title: 'Tracking History' }
      },

      {
        path: 'activities', loadChildren: () => import('app/modules/notifications/notifications.routes'),
        data: { title: 'Activities' },
      },

      {
        path: 'reports', loadChildren: () => import('app/modules/reports/reports.routes'),
        data: { title: 'Reports' }
      },

      {
        path: 'schedule', loadChildren: () => import('app/modules/Scheduler/Schedule/Schedule.routes'),
        data: { title: 'Schedule' },
      },
      {
        path: 'shift-templates', loadChildren: () => import('app/modules/Scheduler/ShiftTemplate/ShiftTemplates.routes'),
        data: { title: 'Shift Templates' }
      },

      {
        path: 'job-instruction', loadChildren: () => import('app/modules/post-order/post-order.routes'),
        data: { title: 'Job Instruction' }
      },

      {
        path: 'dispatch-tickets', loadChildren: () => import('app/modules/Dispatcher/Dispatcher.routes'),
        data: { title: 'Dispatcher' }
      },
      {
        path: 'shift-status', loadChildren: () => import('app/modules/Scheduler/ShiftStatus/ShiftStatus.routes'),
        data: { title: 'Shift-Status' }
      },
      {
        path: 'time-log', loadChildren: () => import('app/modules/TimeClock/TimeLog/TimeLog.routes'),
        data: { title: 'Time Log' }
      },

      {
        path: 'time-card', loadChildren: () => import('app/modules/TimeClock/TimeCard/TimeCard.routes'),
        data: { title: 'Time Card' }
      },
      {
        path: 'job-order', loadChildren: () => import('app/modules/job-order/job-order.routes'),
        data: { title: 'JobOrder' },
      },
      {
        path: 'job-order/:id', loadChildren: () => import('app/modules/job-order/job-order-details/job-order-details.routes'),
        data: { title: 'Job Order Details' },
      },
      {
        path: 'Overview', loadChildren: () => import('app/modules/DocSign/Overview/Overview.routes'),
        data: { title: 'OverView' },
      },
      {
        path: 'documents', loadChildren: () => import('app/modules/DocSign/Documents/Documents.routes'),
        data: { title: 'Documents' },
      },
      {
        path: 'templates', loadChildren: () => import('app/modules/DocSign/templates/templates.routes'),
        data: { title: 'Templates' },
      },
      // Invalid URL → login if expired, else dashboard with menu reloaded
      { path: '**', canActivate: [unknownRouteGuard], children: [] },
    ]
  }
];
